<h3 mat-dialog-title>{{ title }}</h3>
<form [formGroup]="formGroup" (submit)="submit($event)">
  <div mat-dialog-content>
    <div fxLayout="column">
      <div fxLayout="row">
        <mat-form-field fxFlex="45">
          <input
            matInput
            required
            formControlName="startDate"
            type="text"
            [matDatepicker]="startDatepicker"
            placeholder="Start Date"
            (dateChange)="dateChanged()"
            [min]="data.planStartDate.toDate()"
            [max]="data.planEndDate.toDate()"
          />
          <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatepicker></mat-datepicker>
        </mat-form-field>

        <div fxFlex="10"></div>

        <mat-form-field fxFlex="45">
          <input
            matInput
            required
            formControlName="endDate"
            type="text"
            [matDatepicker]="endDatepicker"
            placeholder="End Date"
            (dateChange)="dateChanged()"
            [min]="data.planStartDate.toDate()"
            [max]="data.planEndDate.toDate()"
          />
          <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatepicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div *ngIf="errors.length > 0">
        <ul class="errors" *ngFor="let error of errors;">
          <li class="{{ error.type }}">{{ error.message }}</li>
        </ul>
      </div>

      <mat-form-field fxFlex>
        <input
          matInput
          required
          formControlName="name"
          placeholder="Phase Name"
          (change)="debounceNameChanged($event)"
          (keyup)="debounceNameChanged($event)"
          [matAutocomplete]="phaseName"
        />
      </mat-form-field>

      <mat-autocomplete #phaseName="matAutocomplete" [displayWith]="displayFn" (optionSelected)="nameChanged($event)">
        <mat-option *ngFor="let type of filteredPhaseTypes" [value]="type">
          {{ type.name }}
        </mat-option>
      </mat-autocomplete>

      <mat-form-field fxFlex>
        <mat-select [disabled]="isStandardPhase" required formControlName="color" placeholder="Color">
          <mat-option *ngFor="let color of colors" [value]="color.value">
            {{ color.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions fxLayout="row" fxLayoutAlign="start center">
      <button *ngIf="data.phase" mat-button (click)="delete()">Delete</button>
      <div fxFlex></div>
      <button mat-button matDialogClose>Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="formGroup.invalid || hasErrors">{{ saveButtonText }}</button>
  </div>
</form>
